<template>
  <div class="refund-detail-container">
    <div
      class="status"
      :class="{
        waiting: refundDetail.status < 5,
        'huan-waiting': refundDetail.type == 3 && refundDetail.status == 5,
        'not-approve': refundDetail.status == 6,
        cancel: refundDetail.status == 7,
        success: refundDetail.type != 3 && refundDetail.status == 8,
        'huan-success': refundDetail.type == 3 && refundDetail.status == 8
      }"
    >
      <div
        class="status-show"
        :class="{ center: ![6, 8].includes(refundDetail.status) }"
      >
        {{ getStatus(refundDetail.status) }}
      </div>
      <div class="desc" v-if="refundDetail.status == 6">
      </div>
      <div class="desc" v-if="refundDetail.status == 8">
        {{
          moment(refundDetail.finish_time * 1000).format("YYYY-MM-DD HH:mm:ss")
        }}
      </div>
    </div>
    <!--        寄出地址提示-->
    <div
      class="form-group send-tips"
      v-if="
        refundDetail.status == 2 &&
          refundDetail.express_name == '' &&
          refundDetail.express_num == ''
      "
    >
      <div class="header">
        <img src="@images/send-tips.png" alt="" />
        <span>请按下面地址寄回所需退回的商品</span>
      </div>
      <div class="address">
        <div class="item">收件人：{{ refundDetail.send_name }}</div>
        <div class="item">联系方式：{{ refundDetail.send_phone }}</div>
        <div class="item">公司地址：{{ refundDetail.send_address }}</div>
      </div>
    </div>
    <!--        商品信息-->
    <div class="form-group" v-if="refundDetail.status < 5">
      <RefundGoodsItem
        v-if="Object.keys(cartInfo).length > 0"
        :cart-info="cartInfo"
        :showNumber="false"
      ></RefundGoodsItem>
    </div>
    <!--        原因和件数-->
    <div
      class="form-group"
      v-if="
        (refundDetail.type != 3 && refundDetail.status < 6) ||
          (refundDetail.type == 3 && refundDetail.status < 5)
      "
    >
      <div class="form-item">
        <div class="title">{{ typeShow }}原因：</div>
        <div class="content">
          <span class="left-c">{{ refundDetail.reason_content }}</span>
        </div>
      </div>
      <div class="form-item">
        <div class="title">{{ typeShow }}件数：</div>
        <div class="content" v-if="Object.keys(cartInfo).length > 0">
          <span class="left-c">
            {{ refundDetail.num }} {{ cartInfo.productInfo.unit_name }}
          </span>
        </div>
      </div>
    </div>
    <!--        申请中才显示-->
    <div class="form-group" v-if="refundDetail.status == 0">
      <div class="form-item">
        <div class="title">收货地址：</div>
        <div class="content">
          <div class="address">
            <div class="name-phone">
              <div class="name">{{ refundDetail.name }}</div>
              <div class="phone">{{ refundDetail.phone }}</div>
            </div>
            <div class="address-detail line2">{{ refundDetail.address }}</div>
          </div>
        </div>
      </div>
    </div>
    <!--        退款金额-->
    <div
      class="form-group"
      v-if="refundDetail.type != 3 && refundDetail.status < 6"
    >
      <div class="form-item">
        <div class="title">退款金额：</div>
        <div class="content flex-start">
          ￥{{ refundDetail.back_total_amount }}<span v-if="refundDetail.back_point_money>0">+{{ refundDetail.back_point_money }}购物券</span>
        </div>
      </div>
    </div>

    <!--        售后订单完成后显示的-->
    <div
      class="refund-money-box form-group"
      v-if="refundDetail.type != 3 && refundDetail.status == 8"
    >
      <div class="item summary">
        <div class="title">退款总金额</div>
        <div class="content">￥{{ refundDetail.back_total_amount }}</div>
      </div>
      <div class="item">
        <div class="title">退回运费</div>
        <div class="content">￥{{ refundDetail.back_pay_postage }}</div>
      </div>

      <div class="item">
        <div class="title">退回现金金额</div>
        <div class="content">￥{{ refundDetail.back_pay_price }}</div>
      </div>


      <div v-for="(item, index) in refundDetail.moneyTypeBuyArr" :key="index">
        <div class="item"  v-if="refundDetail['back_'+index]>0">
          <div class="title">{{item}}</div>
          <div class="content">￥{{ refundDetail['back_'+index] }}</div>
        </div>
      </div>




    </div>

    <!--        审核反馈-->
    <div class="reject-reason form-group" v-if="refundDetail.status == 6">
      <div class="title">审核反馈</div>
      <div class="content">{{ refundDetail.apply_remark }}</div>
    </div>

    <!--        售后信息-->
    <div class="refund-detail form-group" v-if="refundDetail.status >= 5">
      <div class="title">售后信息</div>
      <div class="refund-detail-goods">
        <RefundGoodsItem
          v-if="Object.keys(cartInfo).length > 0"
          :cart-info="cartInfo"
          :showNumber="false"
        ></RefundGoodsItem>
      </div>
    </div>

    <!--        物流状态-->
    <div
      class="form-group"
      v-if="
        refundDetail.type != 1 &&
          ((refundDetail.status == 2 &&
            refundDetail.express_name != '' &&
            refundDetail.express_num != '') ||
            [3, 4, 5].includes(refundDetail.status) ||
            (refundDetail.type == 3 && refundDetail.status == 8))
      "
    >
      <div class="form-item">
        <div class="title">物流状态：</div>
        <div class="content" @click="toLogisticsDetail">
          <span class="logistics-status">
            <template
              v-if="
                refundDetail.status == 2 &&
                  refundDetail.express_name != '' &&
                  refundDetail.express_num != ''
              "
            >
              等待商家签收
            </template>
            <template
              v-if="refundDetail.status == 3 || refundDetail.status == 4"
            >
              商家已签收
            </template>
            <template v-if="refundDetail.status == 5">
              商家已发货，等待签收
            </template>
            <template v-if="refundDetail.status == 8">
              已签收
            </template>
            <img class="arrow" src="@images/arrow.png" alt=""
          /></span>
        </div>
      </div>
    </div>

    <!--        图片凭证-->
    <div
      class="form-group img-proof"
      v-if="
        (refundDetail.hasOwnProperty('img_str') &&
          refundDetail.img_str != '') ||
          refundDetail.status >= 5
      "
    >
      <div class="form-item column">
        <div
          class="title"
          v-if="
            refundDetail.hasOwnProperty('img_str') && refundDetail.img_str != ''
          "
        >
          图片凭证
        </div>
        <div class="content">
          <div>
            <div
              class="img-list"
              style="margin-top: 0.2rem;"
              v-if="
                refundDetail.hasOwnProperty('img_str') &&
                  refundDetail.img_str != ''
              "
            >
              <div
                class="img-item"
                v-for="(item, index) in refundDetail.img_str.split(',')"
                :key="index"
              >
                <img :src="item" alt="" />
              </div>
            </div>

            <div class="details" v-if="refundDetail.status >= 5">
              <div class="item">
                <div class="title">退款原因：</div>
                <div class="content">{{ refundDetail.reason_content }}</div>
              </div>
<!--              <div class="item">-->
<!--                <div class="title">退款金额：</div>-->
<!--                <div class="content">-->
<!--                  ￥{{ refundDetail.total_money_return }}-->
<!--                </div>-->
<!--              </div>-->
              <div class="item">
                <div class="title">申请件数：</div>
                <div class="content">{{ refundDetail.num }}</div>
              </div>
              <div class="item">
                <div class="title">订单编号：</div>
                <div class="content">{{ refundDetail.order_return_sn }}</div>
              </div>
              <div class="item">
                <div class="title">申请时间：</div>
                <div class="content">
                  {{
                    moment(refundDetail.add_time * 1000).format(
                      "YYYY-MM-DD HH:mm:ss"
                    )
                  }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

<!--    <div-->
<!--      class="action-btn"-->
<!--      v-if="refundDetail.status == 0"-->
<!--      @click="cancelOrder"-->
<!--    >-->
<!--      取消申请-->
<!--    </div>-->
    <div
      class="action-btn"
      v-if="
        refundDetail.status == 2 &&
          refundDetail.express_name == '' &&
          refundDetail.express_num == ''
      "
      @click="toLogisticsForm"
    >
      填写快递单号
    </div>
  </div>
</template>

<script>
const STATUS = [
  "商家正在审核中......",
  "审核通过，商家正在退款",
  "审核通过，等待买家退货",
  "买家已退货，等待商家退款",
  "买家已退货，等待商家换货",
  "商家已换货",
  "审核未通过，申请取消",
  "",
  ""
];
import moment from "moment";
import RefundGoodsItem from "@components/RefundGoodsItem";
import {
  getOrderReturnDetail,
  getReturnProductInfo,
  cancelOrderReturn
} from "@api/user";
export default {
  name: "RefundDetail",
  components: {
    RefundGoodsItem
  },
  data() {
    return {
      id: null,
      oid: null,
      unique: null,
      cartInfo: {}, //售后商品信息
      refundDetail: {} // 售后订单信息
    };
  },
  created() {
    this.moment = moment;
  },
  mounted() {
    if (!this.$route.query.hasOwnProperty("id")) {
      this.$dialog.error("参数有误");
      setTimeout(() => {
        this.$router.go(-1);
      }, 1000);
    } else {
      this.id = this.$route.query.id;
      this.$nextTick(() => {
        this.getOrderReturnDetail();
      });
    }
  },
  computed: {
    typeShow() {
      return this.refundDetail.hasOwnProperty("type") &&
        this.refundDetail.type == 3
        ? "换货"
        : "退款";
    }
  },
  methods: {
    getStatus(status) {
      if (status == 8 || status == 7) {
        let text;
        switch (this.refundDetail.type) {
          case "1":
            text = "退款";
            break;
          case "2":
            text = "退款退货";
            break;
          case "3":
            text = "换货";
            break;
          case 1:
            text = "退款";
            break;
          case 2:
            text = "退款退货";
            break;
          case 3:
            text = "换货";
            break;
        }
        if (status == 8) {
          return text + "成功";
        } else if (status == 7) {
          return "买家已取消" + text + "申请";
        }
      } else if (
        status == 2 &&
        this.refundDetail.express_name != '' &&
        this.refundDetail.express_num != ''
      ) {
        return "买家已退货，等待商家换货";
      } else {
        return STATUS[status];
      }
    },
    /**
     * 获取售后详情
     */
    getOrderReturnDetail() {
      getOrderReturnDetail({ id: this.id }).then(res => {
        this.oid = res.data.order_id;
        this.unique = res.data.cart_info_unique;
        this.refundDetail = res.data;
        this.$nextTick(() => {
          this.getReturnProductInfo();
        });
      });
    },
    /**
     * 获取子订单信息
     */
    getReturnProductInfo() {
      let params = { oid: this.oid, unique: this.unique };
      getReturnProductInfo(params).then(res => {
        this.cartInfo = res.data.cart_info;
      });
    },
    /**
     * 取消售后订单
     */
    cancelOrder() {
      this.$dialog.confirm({
        mes: "确认取消?",
        opts: () => {
          cancelOrderReturn({ id: this.refundDetail.id })
            .then(res => {
              this.$dialog.success("取消成功");
              this.$router.push("/user/refund_list");
              console.log(res);
            })
            .catch(err => {
              this.$dialog.error(err.msg);
            });
        }
      });
    },
    /**
     * 跳转物流表单
     */
    toLogisticsForm() {
      this.$router.push(
        "/user/refund_logistics_form?id=" + this.refundDetail.id
      );
    },
    /**
     * 跳转物流详情
     */
    toLogisticsDetail() {
      let type;
      if (
        this.refundDetail.status == 2 ||
        this.refundDetail.status == 3 ||
        this.refundDetail.status == 4
      ) {
        type = 1;
      } else {
        type = 2;
      }
      this.$router.push(
        "/user/refund_logistics_detail/" +
          this.id +
          "/" +
          type +
          "/" +
          this.oid +
          "/" +
          this.unique
      );
    }
  }
};
</script>

<style scoped lang="scss">
.refund-detail-container {
  margin-bottom: 1.7rem;
  .status {
    width: 100%;
    height: 1.96rem;

    background-size: 1rem 1rem;
    background-position: 6rem 0.46rem;
    background-repeat: no-repeat;
    padding: 0.32rem;
    color: #fff;
    font-weight: 400;
    .status-show {
      font-size: 0.28rem;
      margin-top: 0.2rem;
      &.center {
        margin-top: 0.5rem;
      }
    }
    .desc {
      margin-top: 0.2rem;
      font-size: 0.22rem;
    }
  }
  .status.waiting {
    background-color: #ec5d59;
    background-image: url("../../../assets/images/refund_waiting.png");
  }
  .status.huan-waiting {
    background-color: #ec5d59;
    background-image: url("../../../assets/images/huan_status.png");
  }
  .status.not-approve {
    background-color: #ccc;
    background-image: url("../../../assets/images/refund_cancel.png");
  }
  .status.cancel {
    background-color: #ccc;
  }
  .status.success {
    background-color: #98e0ae;
    background-image: url("../../../assets/images/refund_success.png");
  }
  .status.huan-success {
    background-color: #98e0ae;
    background-image: url("../../../assets/images/huan_status.png");
  }
  .action-btn {
    position: fixed;
    bottom: 0.4rem;
    left: 50%;
    width: 7rem;
    height: 0.9rem;
    border-radius: 0.45rem;
    background-color: #ec5d59;
    text-align: center;
    line-height: 0.9rem;
    color: #ffffff;
    transform: translateX(-50%);
  }
  .btn-group {
    position: fixed;
    bottom: 0.4rem;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    width: 100%;
    .cancel-btn,
    .logistics-btn {
      width: 3.24rem;
      height: 0.88rem;
      border-radius: 0.44rem;
      line-height: 0.88rem;
      text-align: center;
      font-size: 0.32rem;
      font-weight: 400;
    }
    .cancel-btn {
      color: #ec5d59;
      background-color: #fff;
    }
    .logistics-btn {
      color: #fff;
      background-color: #ec5d59;
    }
  }
  .tips {
    padding: 0.2rem 0.32rem 0 0.32rem;
    color: #999;
    font-size: 0.24rem;
  }
  .form-group {
    background-color: #fff;
    padding: 0.2rem 0.32rem;
    margin-top: 0.2rem;
    &:nth-of-type(2) {
      margin-top: 0;
    }
    .form-item {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: flex-start;
      margin-top: 0.4rem;
      &.column {
        flex-direction: column;
        align-items: flex-start;
      }
      &:first-of-type {
        margin-top: 0;
      }
      > .title {
        color: #333333;
        font-size: 0.28rem;
        text-align: left;
        font-weight: 400;
      }
      > .content {
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        align-items: center;
        flex: 1;
        .logistics-status {
          color: #ec5d59;
          font-size: 0.28rem;
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: space-between;
          width: 100%;
          .arrow {
            width: 0.14rem;
            height: 0.22rem;
          }
        }
        .left-c {
          width: 100%;
          color: #333;
          font-size: 0.28rem;
        }
        .refund-desc {
          width: 100%;
        }
        .img-list {
          display: flex;
          flex-direction: row;
          justify-content: flex-start;
          .img-item {
            width: 2.16rem;
            height: 2.16rem;
            position: relative;
            margin-left: 0.2rem;
            border-radius: 0.6rem;
            &:first-of-type {
              margin-left: 0;
            }
            img {
              width: 100%;
              height: 100%;
            }
          }
        }
        .details {
          .item {
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: center;
            margin-top: 0.2rem;
            color: #999;
            font-size: 0.24rem;
          }
        }
        .upload-action {
          width: 2.16rem;
          height: 2.16rem;
          padding: 0.24rem;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          align-items: center;
          border: 1px dashed #979797;
          img {
            width: 0.96rem;
            height: 0.8rem;
          }
          div {
            text-align: center;
          }
        }
        .address {
          width: 100%;
          .name-phone {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
          }
        }
        &.radio-group {
          justify-content: space-around;
          .radio-text {
            font-size: 0.28rem;
            color: #282828;
            margin-left: 0.45rem;
          }
        }
        &.flex-start {
          justify-content: flex-start;
        }
      }
    }
    &.refund-money-box {
      padding: 0 0.32rem 0.32rem;
      background-color: #fff;
      .item {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        padding-top: 0.2rem;
        .title,
        .content {
          font-size: 0.24rem;
          color: #666;
        }
        &.summary {
          padding: 0.28rem 0;
          border-bottom: 1px solid #f0f0f0;
          .title {
            font-size: 0.28rem;
            color: #333;
          }
          .content {
            font-size: 0.28rem;
            color: #fe5c48;
          }
        }
      }
    }
    &.refund-detail {
      background-color: #fff;
      /*padding:0.2rem 0.32rem 0.4rem;*/
      > .title {
        color: #333;
        font-size: 0.28rem;
      }
      .refund-detail-goods {
        padding: 0.2rem 0;
      }
      .details {
        .item {
          display: flex;
          flex-direction: row;
          justify-content: flex-start;
          align-items: center;
          margin-top: 0.2rem;
          color: #999;
          font-size: 0.24rem;
        }
      }
      .img-list {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        .img-item {
          width: 2.16rem;
          height: 2.16rem;
          position: relative;
          margin-left: 0.2rem;
          border-radius: 0.6rem;
          &:first-of-type {
            margin-left: 0;
          }
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
    &.refund-detail + .img-proof {
      margin-top: 0;
      padding-top: 0;
      .form-item {
        border-top: 1px solid #eee;
        padding-top: 0.2rem;
      }
    }
    &.reject-reason {
      background-color: #fff;
      padding: 0.2rem 0.32rem 0.4rem;
      > .title {
        color: #333;
        font-size: 0.28rem;
      }
      > .content {
        margin-top: 0.2rem;
        color: #333;
        font-size: 0.24rem;
      }
    }
    &.send-tips {
      & > .header {
        img {
          width: 0.26rem;
          height: 0.32rem;
        }
        span {
          margin-left: 0.1rem;
          color: #ec5d59;
          font-size: 0.24rem;
        }
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
      }
      & > .address {
        .item {
          color: #333;
          font-size: 0.28rem;
          margin-top: 0.1rem;
        }
      }
    }
  }
}
</style>
